<template>
  <div
    class="menu_box border_bottom_dashed"
    style="border-top: none; border-bottom: none"
  >
    <div class="flex borderBottomDashed paddingAll20">
      <div class="title_shaixuan flex_jc_center">薪资方式</div>
      <div
        class="classified_content"
        :style="{ height: show ? 'auto' : '46px' }"
        ref="height"
      >
        <div
          class="unfold flex_ai_center"
          :class="show ? 'unfold-red' : ''"
          @click="show = !show"
          v-if="height"
        >
          <span v-show="show">收起<i class="el-icon-arrow-up"></i></span>
          <span v-show="!show">展开<i class="el-icon-arrow-down"></i></span>
        </div>
        <span
          v-for="(item, index) in salaryType"
          :key="'team' + index"
          :class="{ pitch_on: salaryIndex == index }"
          @click="send(item, index)"
        >
          {{ item.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "salaryType",
  data() {
    return {
      salaryType: [
        { name: "全部", no: "" },
        { name: "按量计费", no: 4 },
        { name: "固定薪资", no: 5 },
        { name: "固定薪资+绩效", no: 6 }
      ],
      salaryIndex: "",
      show: true,
      height: false
    }
  },
  watch: {},
  created() {},
  methods: {
    /** @name 搜索单项 */
    send(obj, key) {
      this.salaryIndex = key
      if (key == 0) {
        this.$parent.$refs.screen.salaryType = []
        return
      }
      obj.key = key
      //替换搜索项
      let type = this.$parent.$refs.screen.salaryType.length
      if (type) {
        this.$parent.$refs.screen.salaryType.splice(0, 1, obj)
        return
      }
      //添加搜索项
      this.$parent.$refs.screen.salaryType.push(obj)
    },
    /** @name 清队单项 */
    close(item) {
      this.salaryIndex = ""
    },
    /** @name 清空所有 */
    closeall() {
      this.salaryIndex = ""
    }
  }
}
</script>

<style scoped>
</style>
